import * as classNames from "classnames";
import * as React from 'react';
import { ColumnChart } from 'react-chartkick';

type SampleSizeColumnChartProps = {
    colors: string[];
    data: (string | number)[][];
    legend: boolean;
    sampleSizeData: number[];
    sampleSizeZeroText: any;
    sampleSizeMinimumForResult?: number;
    yScaleMax: number;
    yLabel?: string;
    yLabelHover?: string;
}

type SampleSizeColumnChartActions = {}

type SampleSizeColumnChartAllProps = SampleSizeColumnChartProps & SampleSizeColumnChartActions;

export default class SampleSizeColumnChart extends React.PureComponent<SampleSizeColumnChartAllProps, any> {
    constructor(props, context) {
        super(props, context);
    }


    render() {
        const { colors, data, legend, sampleSizeData: sampleSizes, sampleSizeMinimumForResult, sampleSizeZeroText, yLabelHover, yLabel, yScaleMax } = this.props;

        return <ColumnChart
            legend={legend}
            data={data}
            colors={colors}
            stacked={false}
            library={{
                animation: { easing: 'linear', duration: 0 },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var label = yLabelHover ? yLabelHover : data.datasets[tooltipItem.datasetIndex].label || '';

                            if (label) {
                                label += ': ';
                            }

                            label += sampleSizes[tooltipItem.index] < sampleSizeMinimumForResult 
                                ? 'N/A' 
                                : tooltipItem.yLabel;

                            /*label += sampleSizes[tooltipItem.index] < sampleSizeMinimumForResult 
                                ? 'N/A' 
                                : tooltipItem.yLabel;

                            label += '\n\rSample Size: ' + sampleSizes[tooltipItem.index];*/
                            return label;
                        },
                    },
                    mode: 'index',
                    intersect: false
                },
                plugins: {
                    datalabels: {
                        color: '#000000',
                        formatter: function (value, context) {
                            return sampleSizes[context.dataIndex] < sampleSizeMinimumForResult
                                ? sampleSizeZeroText
                                : sampleSizes[context.dataIndex];
                        },
                        anchor: 'end',
                        align: 'top',
                        clamp: true
                    }
                },
                scales: {
                    yAxes: [{
                        display: true,
                        ticks: {
                            max: yScaleMax
                        },
                        scaleLabel: {
                            display: true,
                            labelString: yLabel ? yLabel : undefined
                        }
                    }]
                }
            }}
        />;
    }
}
